/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagComputedConfigInfos } from '../../models/tag-computed-config-infos';

export interface GetTagComputed$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getTagComputed(http: HttpClient, rootUrl: string, params: GetTagComputed$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedConfigInfos>> {
  const rb = new RequestBuilder(rootUrl, getTagComputed.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagComputedConfigInfos>;
    })
  );
}

getTagComputed.PATH = '/tags-computed/{uid}';
